import { IHousingObjectResponse } from '@/types';
import { StructuredData } from '@/types/structuredData';
import { buildListingListItems } from './buildListingListItems';

const BASE_URL = process.env.BASE_URL ?? 'https://alleimmobilien.at';

type Options = {
  path?: string;
  name?: string;
};

export const generateHousingListSchema = (
  objects: IHousingObjectResponse[],
  numFound: number,
  locale: string,
  { path = '/housing', name = 'Immobiliensuche – AlleImmobilien.at' }: Options = {},
): StructuredData => ({
  '@context': 'https://schema.org',
  '@type': 'SearchResultsPage',
  url: `${BASE_URL}/${locale}${path}`,
  name,
  description: `${numFound} Immobilien gefunden`,
  mainEntity: {
    '@type': 'ItemList',
    numberOfItems: numFound,
    itemListElement: buildListingListItems(objects, locale),
  },
});
